import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
/* eslint-disable no-console */
export const store = new Vuex.Store({
    state:{
        open_tickets:[]
    },
    getters:{
        open_tickets_id: (state)=>{
            var openTicketsId = state.open_tickets.map(ticket =>{
                return ticket.id
            })
            return openTicketsId
        }
    },
    mutations:{
        fdTicketData: (state, payload) => {
            state.open_tickets = [...payload]
        }
    },
    actions:{
        AsyncFdTicketInfo: (context, payload) =>{
            context.commit('fdTicketData',payload)
        }
    },
})